export enum CustomerStatus {
  Normal = 'normal',
  Inactivated = 'inactivated',
  Blocked = 'blocked'
}

export interface Customer {
  username?: string;
  creationdate?: string;
  modificationdate?: string;
  activationdate?: string;
  status?: CustomerStatus;
  plainpassword?: string;
  props?: { [name: string]: any };
}
